import { isEmpty, isEqual } from 'underscore';
import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';

export const serverErrorsCompare = (prev, curr) => !(!isEmpty(curr) && !isEqual(prev, curr));

export const ServerValidatedRemainingCharsValidatedTextField = RemainingCharsValidatedTextField;
